import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "Html",
    component: () => (__SERVER__ ? require("./html-view") : import("./html-view"))
});

export default definition;
